import { render, staticRenderFns } from "./yetkidialog.vue?vue&type=template&id=1ddc590c"
import script from "./yetkidialog.vue?vue&type=script&lang=js"
export * from "./yetkidialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports